import { ContainerModule } from 'inversify';
import { ErrorMonitoringDependencyTypes } from '@shared/common/error-monitoring/error-monitoring.dependency-types';
import { DeferredErrorMonitoringService } from '@shared/common/error-monitoring/domain/service/deferred-error-monitoring.service';

export const errorMonitoringContainerModule = new ContainerModule(({ bind }) => {
  bind<DeferredErrorMonitoringService>(ErrorMonitoringDependencyTypes.ErrorMonitoringService)
    .to(DeferredErrorMonitoringService)
    .inSingletonScope();
});
